export const priorityCustomerListForEclos = [
    '0000408908',
    '0000409976',
    '0000410385',
    '0000411889',
    '0000707742',
    '0000412095',
    '0000412228',
    '0000421363',
    '0000706822',
    '0000428225',
    '0000417954',
    '0000424188',
    '0000425936',
    '0000414657',
    '0000413464',
    '0000413418',
    '0000413535',
    '0000410056',
    '0000413469',
    '0000413701',
    '0000427548',
    '0000414779',
    '0000702667',
    '0000413119',
    '0000413894',
    '0000413212',
    '0000413120',
    '0000413148',
    '0000413153',
    '0000409129',
    '0000411291',
    '0000411798',
    '0000412583',
    '0000409836',
    '0000414458',
    '0000412473',
    '0000410019',
    '0000415776',
    '0000412671',
    '0000412655',
    '0000412861',
    '0000419301',
    '0000412508',
    '0000413699',
    '0000431304',
    '0000417383',
    '0000419385',
    '0000419408',
    '0000419443',
    '0000419273',
    '0000410920',
    '0000411282',
    '0000712109',
    '0000421669',
    '0000415103',
    '0000411828',
    '0000412493',
    '0000408817',
    '0000424456',
    '0000424456',
    '0000409453',
    '0000411163',
    '0000414298',
    '0000422161',
    '0000418300',
    '0000429210',
    '0000412532',
    '0000417373',
    '0000419937',
    '0000420008',
    '0000418479',
    '0000418500',
    '0000419127',
    '0000418585',
    '0000419787',
    '0000420423',
    '0000425212',
    '0000418809',
    '0000423704',
    '0000424649',
    '0000418061',
    '0000427693',
    '0000409623',
    '0000410958',
    '0000713738',
    '0000432754',
    '0000415652',
    '0000410219',
    '0000411055',
    '0000410746',
    '0000434953',
    '0000418960',
    '0000413074',
    '0000420106',
    '0000417682',
    '0000409750',
    '0000420322',
    '0000414016',
    '0000410244',
    '0000413473',
    '0000411567',
    '0000411464',
    '0000412800',
    '0000409288',
    '0000410015',
    '0000423851',
    '0000419019',
    '0000409061',
    '0000423842',
    '0000409567',
    '0000437172',
    '0000410291',
    '0000439616',
    '0000429572',
    '0000420071',
    '0000410321',
    '0000412423',
    '0000412421',
    '0000430331',
    '0000413067',
    '0000422661',
    '0000410530',
    '0000409240',
    '0000411215',
    '0000411215',
    '0000709143',
    '0000409885',
    '0000431803',
    '0000409953',
    '0000435103',
    '0000411043',
    '0000423485',
    '0000411416',
    '0000431504',
    '0000419104',
    '0000411214',
    '0000417180',
    '0000411670',
    '0000412944',
    '0000409607',
    '0000412201',
    '0000413865',
    '0000408992',
    '0000410984',
    '0000411575',
    '0000711349',
    '0000411224',
    '0000409406',
    '0000437557',
    '0000421818',
    '0000412472',
    '0000408912',
    '0000408913',
    '0000410606',
    '0000411312',
    '0000416389',
    '0000409209',
    '0000435013',
    '0000409522',
    '0000432036',
    '0000416802',
    '0000410504',
    '0000430117',
    '0000433174',
    '0000409997',
    '0000409224',
    '0000414597',
    '0000430481',
    '0000415267',
    '0000412469',
    '0000419121',
    '0000409281',
    '0000411506',
    '0000438828',
    '0000432043',
    '0000422830',
    '0000410434',
    '0000440076',
    '0000416957',
    '0000413012',
    '0000434225',
    '0000421420',
    '0000417548',
    '0000431649',
    '0000435106',
    '0000421573',
    '0000423115',
    '0000410513',
    '0000438148',
    '0000410844',
    '0000415967',
    '0000425168',
    '0000426053',
    '0000453345',
]
